module.exports = __webpack_public_path__ + "media/account-app/features/settings/credit-card-icon-set-580d11bc0c2c21d743ae3bd70b5b3a30.png";